import React from 'react'
import {
  useFormContext,
  RegisterOptions,
  Path,
  FieldValues,
} from 'react-hook-form'
import { RequiredIndicator } from './RequiredIndicator'

interface TextFieldProps<TFormValues extends FieldValues> {
  name: Path<TFormValues>
  label: string
  validation?: RegisterOptions
  type?: string
  className?: string
  required?: boolean
}

export function TextField<TFormValues extends FieldValues>({
  name,
  label,
  validation,
  type = 'text',
  className,
  required = false,
}: TextFieldProps<TFormValues>) {
  const {
    register,
    formState: { errors },
  } = useFormContext<TFormValues>()

  const error = (errors as any)[name]?.message as string | undefined

  return (
    <div className={className || 'form-group'}>
      <label htmlFor={name}>
        {label}
        {required && <RequiredIndicator />}
      </label>
      <input
        id={name}
        {...register(
          name,
          validation as RegisterOptions<TFormValues, Path<TFormValues>>
        )}
        type={type}
      />
      {error && <p role="alert">{error}</p>}
    </div>
  )
}
